



















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { mapBrand } from '@shared/helpers/brands/mapBrand';
import { IBrand, IBrandPageContent } from '@shared/types/IBrand';
import { BaseList, BaseListItem } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

import SearchResultsBrandCard from '../SearchResultsBrandCard/SearchResultsBrandCard.vue';

export default defineComponent({
  name: 'SearchResultsBrands',
  components: {
    SearchResultsBrandCard,
    BaseList,
    BaseListItem,
  },
  props: {
    brands: {
      type: Array as PropType<IBrandPageContent[]>,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const mappedBrands = props.brands.map(mapBrand).filter(Boolean) as IBrand[];

    const getImageSrc = (brand: IBrand) =>
      brand.logo?.filename ? getStoryblokImageURL(brand.logo?.filename, { width: 200 }) : null;

    const getImageAlt = (brand: IBrand) => brand.logo?.alt ?? brand.name;

    const getLink = (brand: IBrand) =>
      `/brands/${brand.slug}${props.query ? `?q=${props.query}` : ''}`;

    return {
      mappedBrands,
      getImageSrc,
      getImageAlt,
      getLink,
    };
  },
});
